import PasswordCreated from '../../components/login/PasswordCreated';

const PasswordCreatedPortal = (props) => (
  <PasswordCreated {...props} />
);

export default PasswordCreatedPortal;
